// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Az5H","inner":"styles_inner__3RtZ9","right":"styles_right__qgOcx","close":"styles_close__3l6mX","footer":"styles_footer__2qPVE"};